import { ComponentType, ReactNode, useContext, useState } from 'react'
import { Button, Divider, Switch } from 'antd'

import { ColumnsType } from 'antd/es/table'
import EACardRaw from 'Components/UI/EACard'
import EAReportContext, { EAReportContextValue } from 'Components/UI/EAReport/Context'
import { SumDataEntry } from 'Components/UI/EAReport/Export/utils/csv/exportToCSV'

import exportToCSV from './utils/csv/exportToCSV'
import exportToPDF from './utils/pdf/exportToPDF'
import gerarPDFEncomenda from './utils/pdf/gerarPDFEncomenda'
import exportToXLS from './utils/xls/exportToXLS'

interface EACardProps {
  size?: string
  title?: string
  loading?: boolean
  children: ReactNode
}

const EACard = EACardRaw as unknown as ComponentType<EACardProps>

interface EAReportExportProps<T extends object> {
  columns: ColumnsType<T>
  dataSource: T[]
  filtrosDetalhados: string[] | null
  reportName: string
  isEncomenda?: boolean
  sumData?: SumDataEntry[] | null
  allowExportDetails?: boolean
  forceExportDetails?: boolean
}

/* TODO: verificar a filtragem das colunas exportáveis */
const EAReportExport = <T extends object>({
  columns,
  dataSource,
  filtrosDetalhados,
  reportName,
  isEncomenda = false,
  sumData = null,
  allowExportDetails = false,
  forceExportDetails = false,
}: EAReportExportProps<T>) => {
  const ctx = useContext(EAReportContext) as unknown as EAReportContextValue
  const [exportDetails, setExportDetails] = useState(false)
  const shouldExportDetails = forceExportDetails || exportDetails

  if (dataSource.length === 0) return null

  const exportableColumns = columns.filter((column) => (column as { exportable?: boolean }).exportable !== false)

  const sumDataOrUndefined = sumData ?? undefined
  const filtrosOrUndefined = filtrosDetalhados ?? undefined

  const handlePDFClick = () => {
    if (isEncomenda) {
      gerarPDFEncomenda({
        dataSource: dataSource as unknown as Parameters<typeof gerarPDFEncomenda>[0]['dataSource'],
        filtrosDetalhados: filtrosOrUndefined,
        reportName,
        title: ctx.title,
        sumData: sumDataOrUndefined,
      })
    } else {
      exportToPDF({
        columns: exportableColumns,
        dataSource,
        filtrosDetalhados: filtrosOrUndefined,
        reportName,
        title: ctx.title,
        exportDetails: shouldExportDetails,
      })
    }
  }

  return (
    <EACard size="small" title="Exportar dados do relatório">
      <Button
        onClick={() => {
          exportToCSV({
            columns: exportableColumns,
            dataSource,
            reportName,
            exportDetails: shouldExportDetails,
            sumData: sumDataOrUndefined,
          })
        }}
      >
        CSV
      </Button>

      <Divider type="vertical" />

      <Button onClick={handlePDFClick}>PDF</Button>

      <Divider type="vertical" />

      <Button
        onClick={() => {
          exportToXLS({
            columns: exportableColumns,
            dataSource,
            reportName,
            sumData: sumDataOrUndefined,
            exportDetails: shouldExportDetails,
          })
        }}
      >
        XLS
      </Button>

      {allowExportDetails && (
        <>
          <Divider type="vertical" />
          <Switch
            title="Exportar Detalhes"
            checked={shouldExportDetails}
            disabled={forceExportDetails}
            onChange={setExportDetails}
          />
        </>
      )}
    </EACard>
  )
}

export default EAReportExport
